var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { createSelector } from 'reselect';
import { GET_CURRENT_USER_SUCCESS, GET_USERS_STATS_SUCCESS, GET_USERS_SUCCESS, SET_BLOCK_INCOMING_CALLS } from './users.action';
export var initialState = {
    users: [],
    usersStats: null
};
export function usersReducer(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case GET_USERS_SUCCESS:
            return __assign({}, state, { users: action.payload });
        case GET_CURRENT_USER_SUCCESS:
            return __assign({}, state, { users: action.payload });
        case GET_USERS_STATS_SUCCESS:
            return __assign({}, state, { usersStats: action.payload });
        case SET_BLOCK_INCOMING_CALLS:
            var userIndex = state.users.findIndex(function (userDetails) { return userDetails.id === action.payload.id; });
            state.users[userIndex].doNotAcceptIncomingCalls = action.payload.blocked;
            return __assign({}, state, { usersStats: action.payload });
        default: {
            return state;
        }
    }
}
export var getUsers = function (state) { return state.users; };
export var getUsersStats = function (state) { return state.usersStats; };
export var getMainUsersSelector = function (state) { return state.users; };
export var getUsersSelector = createSelector(getMainUsersSelector, getUsers);
export var getUsersStatsSelector = createSelector(getMainUsersSelector, getUsersStats);
